
import $ from 'jquery'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import html2canvas from 'html2canvas'
import api from '@/api/api'
export default {
name: 'screen_shot',
props: {
// url: String,
fn_close: Function
},
data() {
return {
show_panel: false,
show_loading: true,
token: ''
}
},
methods: {
/**
* 初始化截图
*/
init() {
this.show_panel = true
// 初始化登录流程
this.initAuth()
// 滚动到页面顶部
$('body').scrollTop(0)
// 延时进行加载图片
setTimeout(() => {
this.startShot()
.then(baseUrl => {
return this.base2url(baseUrl)
})
.then(url => {
document.querySelector('.showPic').setAttribute('src', url)
let timer = setInterval(() => {
if (document.querySelector('.showPic').complete) {
clearInterval(timer)
// 关闭loading页面
this.show_loading = false
}
}, 100)
})
}, 500)
},

/**
* 初始化登录来获得token
*/
initAuth() {
api.user.getCurrentUser(user => {
if (user.status !== 200) {
// 记录现有的url
window.localStorage.beforeUrl = window.location.href
// 跳转
let redUrl = encodeURI(window.location.origin + '/login')
let url = `https://wechatauth.aiyaopai.com/auth/clientside?appid=wx76b9a692b8709d44&redirect_uri=${redUrl}&response_type=code&scope=snsapi_userinfo&state=21`
window.location.href = url
}
})
},

/**
* @augments base64 base64文件地址
* base64转化为七牛图片链接
* 文档 https://developer.qiniu.com/kodo/kb/1326/how-to-upload-photos-to-seven-niuyun-base64-code
* 范例 http://blog.csdn.net/Jill6693484/article/details/57081815
*/
base2url(base64) {
let _this = this
return new Promise((resolve, reject) => {
var pic = base64.replace(/^.*?,/, '')
api.base
.getQiniuToken()
.then(res => {
var token = res.data.Token
// 把字符串转换成json
function strToJson(str) {
var json = eval('(' + str + ')')
return json
}
var url = 'https://upload.qiniu.com/putb64/-1/'
var xhr = new XMLHttpRequest()
xhr.onreadystatechange = function() {
if (xhr.readyState == 4) {
var keyText = xhr.responseText
// 返回的key是字符串，需要装换成json
keyText = strToJson(keyText)
resolve(keyText.url)
}
}
xhr.open('POST', url, true)
xhr.setRequestHeader('Content-Type', 'application/octet-stream')
xhr.setRequestHeader('Authorization', 'UpToken ' + token)
xhr.send(pic)
})
.catch(err => {
reject(err)
})
})
},

/**
* @augments
* 开始渲染图片
*/
startShot() {
let _this = this
// 设置qrcode宽高
// this.$refs.qrcode.$el.querySelector('img').style.width = '100px'
// this.$refs.qrcode.$el.querySelector('img').style.height = '100px'
return new Promise((resolve, reject) => {
html2canvas(document.querySelector('#shot'), {
useCORS: true, // 设置图片跨域
logging: false, // 设置日志不打印
// imageTimeout: 0,
async: false, // 设置同步加载图片
height: $('#shot').outerHeight() // 设置生成图片高度等于div实际渲染高度
})
.then(canvas => {
$('#hidepic').html(canvas) //生成的原始canvas画布保留以备其他使用
var img = new Image()
var myCanvas = document.getElementById('myCanvas')
// 设置宽高
myCanvas.width = canvas.width // 注意：没有单位
myCanvas.height = canvas.height //注意：没有单位
var ctx = myCanvas.getContext('2d')
if (img.complete) {
img.src = canvas.toDataURL('image/jpeg') //由于图片异步加载，一定要等img加载好，再设置src属性
img.onload = function() {
// 绘制图片
ctx.drawImage(img, 0, 0)
// 清理dom结构
document.getElementById('shot').outerHTML = ''
// 渲染图片，并导出压缩版jpeg图
let url = myCanvas.toDataURL('image/jpeg')
resolve(url)
}
}
})
.catch(err => {
reject(err)
})
})
},

/**@augments
* 关闭截图页面
*/
close() {
this.show_panel = false
this.show_loading = true
this.fn_close()
}
},

components: {
Qrcode
}
}



// WEBPACK FOOTER //
// ./src/components/XShot/Shot.vue